<template>
    <div>
        <ul class="list-colors">
            <li v-for="tag in tagsDefault" :key="tag.id" :class="`tag-board-color-${tag.id}`">
                <div class="input-change">
                    <input :ref="'input-' + tag.id" type="text" :placeholder="tag.value">
                </div>
            </li>
        </ul>
        <button class="btn btn-primary bg-gray mt-3" @click="handleSaveTag">Salvar</button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tagsDefault: [
                { id: 'verde-escuro', value: 'Verde Escuro', },
                { id: 'verde', value: 'Verde', },
                { id: 'verde-claro', value: 'Verde Claro', },
                { id: 'limao', value: 'Verde Limão', },
                { id: 'azul-escuro', value: 'Azul Escuro', },
                { id: 'azul', value: 'Azul', },
                { id: 'azul-claro', value: 'Azul Claro', },
                { id: 'laranja-escuro', value: 'Laranja Escuro', },
                { id: 'laranja', value: 'Laranja', },
                { id: 'laranja-claro', value: 'Laranja Claro', },
                { id: 'amarelo', value: 'Amarelo', },
                { id: 'amarelo-claro', value: 'Amarelo Claro', },
                { id: 'vermelho', value: 'Vermelho', },
                { id: 'vermelho-claro', value: 'Vermelho Claro', },
                { id: 'preto', value: 'Preto', },
                { id: 'preto-claro', value: 'Cinza', },
                { id: 'castanho', value: 'Castanho', },
                { id: 'roxo', value: 'Roxo', },
                { id: 'lilas', value: 'Lilas', },
                { id: 'rosa', value: 'Rosa', },
                { id: 'rosa-claro', value: 'Rosa Claro', }
            ],
            editItem: false
        }
    },
    methods: {
        handleSaveTag() {
            const data = [];
            this.tagsDefault.map(tag => {
                let ref = this.$refs['input-' + tag.id];
                if (Array.isArray(ref)) ref = ref[0];
                const valor = ref ? ref.value : '';
                const originalValue = this.tagsDefault.find(e=> e.id === tag.id)
                const reult = {
                    id: tag.id,
                    value: valor ? valor : originalValue.value
                }
                data.push(reult)
            })
            console.log(data);
        },
    }
}
</script>
<style scoped>
ul.list-colors {
    max-height: 250px;
    overflow-x: auto;
    border-radius: 4px;
    background: #FFF;
}

ul.list-colors,
ul.list-colors li {
    margin: 0px;
    padding: 0px;
    list-style: none;
}

ul.list-colors li {
    position: relative;
    float: left;
    width: 100%;
    border-top: none;
    margin-bottom: 8px;
    color: #FFF;
    padding: 0px;
    border-radius: 8px;
}

ul.list-colors li>a {
    margin-right: 10px;
    cursor: pointer;
}

.input-change {
    position: relative;
    float: left;
    padding: 12px 24px;
    border-radius: 4px;
    width: 100%;
}

.input-change>div {
    position: absolute;
    float: left;
    width: 100%;
    height: 100%;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
}

.input-change.active>div {
    z-index: -1;
}

.input-change>input {
    background: none;
    border: none;
    width: 94%;
    color: #FFF;
}

.input-change>span {
    display: none;
}

.input-change.active>span {
    display: inline-block;
}

.remove-btn {
    padding: 0px;
    font-size: 14px;
    line-height: 14px;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    margin-right: 0px;
    text-align: center;
}

input:focus {
    border: none;
    box-shadow: none !important;
    outline: none;
}


.tag-board-color-verde-claro>.input-change>input,
.tag-board-color-limao .input-change>input,
.tag-board-color-amarelo .input-change>input,
.tag-board-color-amarelo-claro .input-change>input,
.tag-board-color-lilas .input-change>input,
.tag-board-color-rosa .input-change>input,
.tag-board-color-rosa-claro .input-change>input {
    color: #000
}
</style>